import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.scss";
import { useAppContext } from "../../../AppContext";

const RELEASE_VERSION = "1.2.9";
const RELEASE_SUMMARY =
  "Focused improvements for reporting accuracy, and discount clarity.";
const RELEASE_NOTES = [
  "Performance improvements across key screens.",
  "More accurate discount details.",
  "More reliable sales reports.",
  "Top Selling Items dashboard updated.",
  "Group by Sales Checks now includes order reference from POS.",
];

// const getBasePath = (pathname) => {
//   // Returns "/app" or the first 2 segments of the path
//   const parts = pathname.split("/");
//   return parts.length > 2 ? `/${parts[1]}/${parts[2]}` : "/app";
// };

const Sidebar = () => {
  const location = useLocation();
  const { user, toggle, setToggle } = useAppContext();
  const [menu, setMenu] = useState([]);
  const [page, setPage] = useState("Today");
  const [showWhatsNew, setShowWhatsNew] = useState(false);

  // Build menu on mount and when location/user changes
  useEffect(() => {
    const matchPath = "/app";

    setMenu([
      {
        name: "Dashboard",
        icon: "tachometer-alt",
        path: `${matchPath}/dashboard`,
      },
      {
        name: "Sales",
        icon: "funnel-dollar",
        path: `${matchPath}/sales`,
        level: [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        ],
        auth: true,
        user: ["admin", "demo", "user"],
        items: {
          state: false,
          list: [
            {
              name: "Group by Sales Summary",
              icon: "dollar-sign",
              path: `${matchPath}/sales/summary`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["demo", "user"],
            },
            {
              name: "Group by Session Summary",
              icon: "clock",
              path: `${matchPath}/sales/session`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["demo", "user"],
            },
            {
              name: "Group by Revenue Center",
              icon: "comments-dollar",
              path: `${matchPath}/sales/revcent`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["demo", "user"],
            },
            {
              name: "Group by Payment Type",
              icon: "money-bill",
              path: `${matchPath}/sales/paytype`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["demo", "user"],
            },
            {
              name: "Group by Sales Checks",
              icon: "receipt",
              path: `${matchPath}/sales/checks`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["demo", "user"],
            },
            {
              name: "Group Items by Sales",
              icon: "shopping-basket",
              path: `${matchPath}/sales/item`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["demo", "user"],
            },
            {
              name: "Group Sales by Group Items",
              icon: "shopping-basket",
              path: `${matchPath}/sales/group`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["demo", "user"],
            },
            {
              name: "Hourly Sales",
              icon: "clock",
              path: `${matchPath}/sales/hourly`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["demo", "user"],
            },
            {
              name: "Item Sales by Revenue Center",
              icon: "bell-concierge",
              path: `${matchPath}/sales/revcentItem`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["demo", "user"],
            },
          ],
        },
      },
      {
        name: "Audit",
        icon: "clipboard-list",
        path: `${matchPath}/audit`,
        level: [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        ],
        auth: true,
        user: ["admin", "demo", "user"],
        items: {
          state: false,
          list: [
            {
              name: "Audit Summary",
              icon: "list-alt",
              path: `${matchPath}/audit/logs`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["demo", "user"],
            },
            {
              name: "Void Summary",
              icon: "ban",
              path: `${matchPath}/audit/voids`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["demo", "user"],
            },
            {
              name: "Deletion Summary",
              icon: "trash-alt",
              path: `${matchPath}/audit/deletion`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["demo", "user"],
            },
            {
              name: "Detailed Discount Summary",
              icon: "tags",
              path: `${matchPath}/audit/discount`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["demo", "user"],
            },
          ],
        },
      },
      {
        name: "Menu",
        icon: "utensils",
        path: `${matchPath}/menuEngineering`,
        level: [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        ],
        auth: true,
        user: ["admin", "demo", "user"],
        items: {
          state: false,
          list: [
            {
              name: "Menu Engineering",
              icon: "chart-pie",
              path: `${matchPath}/menuEngineering/menu-dashboard`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["admin", "demo", "user"],
            },
            {
              name: "Outlet Comparison",
              icon: "code-compare",
              path: `${matchPath}/menuEngineering/multi-outlet-comparison`,
              badge: "Soon",
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["admin", "demo", "user"],
            },
            {
              name: "Menu Layout AI",
              icon: "list-ol",
              path: `${matchPath}/menuEngineering/menu-order`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["admin", "demo", "user"],
            },
          ],
        },
      },
      {
        name: "Reports",
        icon: "file-alt",
        path: `${matchPath}/menuReports`,
        level: [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        ],
        auth: true,
        user: ["admin", "demo", "user"],
        items: {
          state: false,
          list: [
            {
              name: "Menu Engineering",
              icon: "utensils",
              path: `${matchPath}/menuReports/menu-engineering`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["demo", "user"],
            },
            {
              name: "Menu by Item Rank",
              icon: "ranking-star",
              path: `${matchPath}/menuReports/item-rank`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["demo", "user"],
            },
          ],
        },
      },
      {
        name: "Manage Accounts",
        icon: "layer-group",
        path: `${matchPath}/account`,
        auth: true,
        level: [1],
        user: ["admin"],
        items: {
          state: false,
          list: [
            {
              name: "Manage Groups",
              icon: "briefcase",
              path: `${matchPath}/group/main`,
              auth: true,
              level: [1],
              user: ["admin"],
            },
            {
              name: "Manage Brands",
              icon: "store",
              path: `${matchPath}/group/brand`,
              auth: true,
              level: [1],
              user: ["admin"],
            },
            {
              name: "Manage Outlets",
              icon: "tags",
              path: `${matchPath}/group/outlet`,
              auth: true,
              level: [1],
              user: ["admin"],
            },
          ],
        },
      },
      {
        name: "Manage Users",
        icon: "users",
        path: `${matchPath}/user`,
        auth: true,
        level: [1],
        user: ["admin"],
      },
      {
        name: "PDF Reports",
        icon: "copy",
        path: `${matchPath}/reports`,
        level: [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        ],
        auth: true,
        user: ["admin", "demo", "user"],
      },
      {
        name: "Analytics",
        icon: "chart-bar",
        path: `${matchPath}/analytics`,
        level: [1],
        auth: true,
        user: ["admin"],
        items: {
          state: false,
          list: [
            {
              name: "Device Analytics",
              icon: "user-friends",
              path: `${matchPath}/analytics/device/list`,
              level: [1],
              auth: true,
              user: ["admin"],
            },
          ],
        },
      },
      {
        name: "Settings",
        icon: "gears",
        path: `${matchPath}/settings`,
        level: [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        ],
        auth: true,
        user: ["admin", "demo", "user"],
        items: {
          state: false,
          list: [
            {
              name: "Outlet Targets",
              icon: "arrow-alt-circle-up",
              path: `${matchPath}/settings/outlet/targets`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["admin", "demo", "user"],
            },
            {
              name: "Season Calendar",
              icon: "calendar-alt",
              path: `${matchPath}/settings/seasons`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["admin", "demo", "user"],
            },
            {
              name: "Dayparts",
              icon: "clock",
              path: `${matchPath}/settings/dayparts`,
              level: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20,
              ],
              auth: true,
              user: ["admin", "demo", "user"],
            },
          ],
        },
      },
    ]);
  }, [location.pathname, user]);

  // Set selected page on mount and when location changes
  useEffect(() => {
    // const found = menu.find(
    //   (menuItem) =>
    //     menuItem.path === location.pathname.split("/").slice(0, 3).join("/")
    // );
    // if (found) setPage(found.name);
    const currentPath = location.pathname;
    let foundSubmenuMatch = false;

    // First, check for submenu matches
    menu.forEach((menuItem) => {
      if (menuItem.items && menuItem.items.list) {
        const subMenuMatch = menuItem.items.list.find(
          (subItem) => subItem.path === currentPath
        );

        if (subMenuMatch && !foundSubmenuMatch) {
          foundSubmenuMatch = true;
          setPage(subMenuMatch.name);

          // Keep the parent menu open
          setMenu((prevMenu) =>
            prevMenu.map((item) =>
              item.name === menuItem.name
                ? { ...item, items: { ...item.items, state: true } }
                : item
            )
          );
        }
      }
    });

    // If no submenu match found, check for main menu match
    if (!foundSubmenuMatch) {
      const mainMenuMatch = menu.find(
        (menuItem) =>
          menuItem.path === currentPath.split("/").slice(0, 3).join("/")
      );

      if (mainMenuMatch) {
        setPage(mainMenuMatch.name);
        // Close all submenus when navigating to main menu
        setMenu((prevMenu) =>
          prevMenu.map((item) =>
            item.items
              ? { ...item, items: { ...item.items, state: false } }
              : item
          )
        );
      }
    }
  }, [location.pathname]);

  // Toggle sidebar open/close
  const handleToggleSide = () => setToggle((prev) => !prev);

  // Toggle dropdown menu open/close
  const handleToggleSub = (menuName) => {
    const initialMenu = menu.map((list) => {
      if (list.name === menuName) {
        return {
          ...list,
          items: {
            ...list.items,
            state: list.items.state ? false : true,
          },
        };
      } else {
        if (list.items) {
          return {
            ...list,
            items: {
              ...list.items,
              state: false,
            },
          };
        }

        return list;
      }
    });

    setMenu(initialMenu);
    setPage(menuName);
  };

  // Set selected page for menu/submenu
  const handleToggleMenu = (menuName) => {
    setPage(menuName);
    // Close all submenus when clicking main menu items
    setMenu((prevMenu) =>
      prevMenu.map((item) =>
        item.items ? { ...item, items: { ...item.items, state: false } } : item
      )
    );
  };

  // Handle submenu clicks - keep parent open
  const handleSubmenuClick = (submenuName, parentMenuName) => {
    setPage(submenuName);
    // Keep parent menu open
    setMenu((prevMenu) =>
      prevMenu.map((item) =>
        item.name === parentMenuName
          ? { ...item, items: { ...item.items, state: true } }
          : item
      )
    );
  };

  const renderSubList = (menu, parentMenu) => {
    if (
      user.data?.type === "admin" ||
      (menu.level && menu.level.includes(user.data?.level))
    ) {
      return (
        <Link
          to={menu.path}
          key={menu.name}
          state={{ prevUrl: location.pathname }}
          className={[
            "subLink",
            menu.name === page ? "subLinkSelected" : "",
          ].join(" ")}
          onClick={() => handleSubmenuClick(menu.name, parentMenu.name)}
        >
          <FontAwesomeIcon className="icon" icon={["fas", menu.icon]} />
          <div className="text">{menu.name}</div>
          {menu.badge ? (
            <span className="comingSoonBadge">{menu.badge}</span>
          ) : null}
        </Link>
      );
    }
    return null;
  };

  //RenderList
  const renderList = (menu) => (
    <div
      className={[
        "link",
        menu.name === page || (menu.items && menu.items.state)
          ? "linkSelected"
          : "",
      ].join(" ")}
      key={menu.name}
    >
      <div className="menuContainer">
        {menu.items ? (
          <div className="dropDown">
            <button onClick={() => handleToggleSub(menu.name)}>
              <div className="dropCont">
                <FontAwesomeIcon className="icon" icon={["fas", menu.icon]} />
                <div className="text">{menu.name}</div>
              </div>
              <FontAwesomeIcon
                className="dropIcon"
                icon={["fas", menu.items.state ? "chevron-up" : "chevron-down"]}
              />
            </button>
          </div>
        ) : (
          <Link to={menu.path} onClick={() => handleToggleMenu(menu.name)}>
            <FontAwesomeIcon className="icon" icon={["fas", menu.icon]} />
            <div className="text">{menu.name}</div>
          </Link>
        )}
      </div>
      <div
        className={[
          "subList",
          menu.items && menu.items.state ? "subListActive" : "",
        ].join(" ")}
      >
        {menu.items && menu.items.state
          ? menu.items.list.map((item) => renderSubList(item, menu))
          : null}
      </div>
    </div>
  );

  return (
    <nav className="sidebar">
      <div className="toggle">
        <div className="title">
          <h1>POS Insights</h1>
        </div>
        <div className={toggle ? "toggleSelect" : ""}>
          <button
            onClick={() => {
              handleToggleSide();
            }}
          >
            <FontAwesomeIcon className="icon" icon={["fas", "bars"]} />
          </button>
        </div>
      </div>
      <ul className="sidebarLink">
        {menu.map((menuItem) => {
          if (menuItem.auth && user.data) {
            if (menuItem.user.includes(user.data.type)) {
              if (
                user.data.type === "admin" ||
                (menuItem.level && menuItem.level.includes(user.data.level))
              ) {
                return <li key={menuItem.name}>{renderList(menuItem)}</li>;
              }
            }
            return <li key={menuItem.name} />;
          }
          return <li key={menuItem.name}>{renderList(menuItem)}</li>;
        })}
      </ul>
      <div className="whatsNewContainer">
        <button
          type="button"
          className="whatsNewButton"
          onClick={() => setShowWhatsNew(true)}
          aria-label="What's New"
        >
          <FontAwesomeIcon
            className="announceIcon"
            icon={["fas", "bullhorn"]}
            aria-hidden="true"
          />
          <span className="text">{toggle ? "" : `V${RELEASE_VERSION}`}</span>
        </button>
      </div>

      {showWhatsNew ? (
        <div
          className="whatsNewModalOverlay"
          onClick={() => setShowWhatsNew(false)}
        >
          <div
            className="whatsNewModal"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="whatsNewModalHeader">
              <h3>What's New</h3>
              <button
                type="button"
                className="closeBtn"
                onClick={() => setShowWhatsNew(false)}
                aria-label="Close What's New"
              >
                ×
              </button>
            </div>
            <p className="version">Release Version: v{RELEASE_VERSION}</p>
            <p className="subtitle">{RELEASE_SUMMARY}</p>
            <ul className="notesList">
              {RELEASE_NOTES.map((note) => (
                <li key={note}>{note}</li>
              ))}
            </ul>
          </div>
        </div>
      ) : null}
    </nav>
  );
};

export default Sidebar;
